<app-navbar />

<main id="main-content">
  <section class="page-hero">
    <div class="container">
      <app-breadcrumb [trail]="[{ label: 'Privacy Policy' }]" />
      <span class="eyebrow">Legal</span>
      <h1>Privacy Policy</h1>
      <p>Last updated {{ updated }}</p>
    </div>
  </section>

  <section class="section">
    <div class="container">
      <div class="legal-layout">
        <aside class="legal-toc">
          <p class="legal-toc-title">On this page</p>
          <nav>
            <a [routerLink]="[]" fragment="collect">Information we collect</a>
            <a [routerLink]="[]" fragment="use">How we use information</a>
            <a [routerLink]="[]" fragment="share">How we share information</a>
            <a [routerLink]="[]" fragment="retention">Data retention</a>
            <a [routerLink]="[]" fragment="security">Security</a>
            <a [routerLink]="[]" fragment="choices">Your choices</a>
            <a [routerLink]="[]" fragment="contact">Contact us</a>
          </nav>
        </aside>

        <div class="legal-body">
          <div class="prose legal-prose">
            <p class="legal-intro">
              This Privacy Policy explains how {{ site.legalName }}, operating as {{ site.name }},
              collects, uses and protects information when you use our website and services. By using
              our services you agree to the practices described here.
            </p>

            <h2 id="collect">Information we collect</h2>
            <p>We collect the following types of information:</p>
            <ul>
              <li>
                Account information such as your name, work email, company and phone number when you
                create an account or contact us.
              </li>
              <li>
                Verification data, meaning the identity records you submit so that we can check them
                against death records.
              </li>
              <li>
                Usage information such as log data, device details and how you interact with the
                service, used to keep the service secure and reliable.
              </li>
            </ul>

            <h2 id="use">How we use information</h2>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Provide deceased verification results and operate the service.</li>
              <li>Communicate with you about your account, support and updates.</li>
              <li>Bill for usage and prevent fraud and abuse.</li>
              <li>Improve the accuracy, speed and security of the platform.</li>
            </ul>

            <h2 id="share">How we share information</h2>
            <p>
              We do not sell the verification records you submit. We may share information with service
              providers who help us operate the platform, and where required by law. Any provider we
              use is bound by obligations to protect your data.
            </p>

            <h2 id="retention">Data retention</h2>
            <p>
              We retain the records you submit only as long as needed to deliver results and meet legal
              and operational requirements, then remove them on a defined schedule. Account information
              is retained for the life of your account.
            </p>

            <h2 id="security">Security</h2>
            <p>
              We protect data with encryption in transit and at rest, least privilege access controls,
              logging and hardened infrastructure. No method of transmission or storage is perfectly
              secure, but we work continuously to protect your information.
            </p>

            <h2 id="choices">Your choices</h2>
            <p>
              You may request access to, correction of, or deletion of your account information by
              contacting us. Depending on your location, you may have additional rights under
              applicable privacy laws.
            </p>

            <h2 id="contact">Contact us</h2>
            <p>
              If you have questions about this policy, contact us at
              <a [href]="'mailto:' + site.email">{{ site.email }}</a> or write to us at
              {{ site.address }}.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>

<app-footer />
